import React from "react";
import { CoreText, CoreTextType } from "../text/text";
import "../input/core_field.css";

export const CoreSelect = (props: {
  items?: string[];
  options?: { value: string; label: string }[];
  value: string;
  label: string;
  onChange: (value: string, index: number) => void;
  disabled?: boolean;
  isInput?: boolean;
  style?: React.CSSProperties;
}) => {
  const id = React.useId();
  const options = props.options ?? (props.items ?? []).map(value => ({ value, label: value }));
  return <div className="core-field" style={props.style}>
    <label htmlFor={id}><CoreText as="span" type={CoreTextType.small} text={props.label} /></label>
    <select id={id} value={props.value} disabled={props.disabled}
      onChange={event => props.onChange(event.target.value, event.target.selectedIndex)}>
      {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
  </div>;
};
